import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Trans from './Trans';

interface MainContentItem {
	title: string;
	content: string;
}

interface MainContentData {
	mainContentItems: MainContentItem[];
	columns: number;
	showAllItems: boolean;
	length: number;
	showButton: boolean;
}

const MainContent: FC = () => {
	const [columns, setColumns] = React.useState(3);
	const [showAllItems, setShowAllItems] = React.useState(false);
	const { t, i18n, ready } = useTranslation();

	useEffect(() => {
		if (typeof window != 'undefined') {
			window.addEventListener('resize', checkColumns);
			checkColumns();
		}

		return () => {
			window.removeEventListener('resize', checkColumns);
		};
	}, []);

	const checkColumns = () => {
		const width = window.innerWidth;
		let columns = 3;

		if (width < 768) {
			columns = 1;
		} else if (width < 992) {
			columns = 2;
		}
		setColumns(columns);
	};

	const getData = () => {
		let mainContentItems = t('mainContent.items', { returnObjects: true }) as MainContentItem[];

		const length = mainContentItems.length;
		let showButton = false;

		if (columns === 1 && !showAllItems) {
			mainContentItems = mainContentItems.slice(0, length / 3);
			showButton = true;
		}

		return {
			mainContentItems,
			columns,
			showAllItems,
			length,
			showButton,
		};
	};

	const renderItems = (data: MainContentData) => {
		if (Array.isArray(data.mainContentItems)) {
			return (
				<div className="main-content__items">
					{data.mainContentItems.map((item: { title: string; content: string }, key: number) => {
						return (
							<div key={key} className="item">
								<div className="content">
									<h4 className="mb-3">{item.title}</h4>
									<p>{item.content}</p>
								</div>
							</div>
						);
					})}
				</div>
			);
		} else {
			console.error('mainContentItems is not an array:', data.mainContentItems);
			return null;
		}
	};

	if (!ready) {
		return <div>Loading...</div>;
	}

	const data = getData();

	return (
		<div className="container" id="main-content">
			<div className="row justify-content-center">
				<div className="col-11 col-md-12 col-lg-8 mb-5 mt-5">
					<h2 id="title">
						<Trans i18nKey="mainContent.title" />
					</h2>
					<p id="description">
						<Trans i18nKey="mainContent.description" />
					</p>
				</div>
			</div>
			{data && (
				<>
					{renderItems(data)}
					{data.showButton ? (
						<div className="col-12 mb-4">
							<div onClick={() => setShowAllItems(true)} id="show-all-items-btn">
								{t('mainContent.showAllItemsBtn', { count: data.length - data.mainContentItems.length })}
							</div>
						</div>
					) : (
						''
					)}
				</>
			)}
		</div>
	);
};

export default React.memo(MainContent);
